// Login stores the session token under 'authToken' (see AuthContext). Older components read 'token',
// which is never set, so they treated logged-in users as logged out. Read both, preferring 'authToken'.
export const getAuthToken = (): string | null =>
  localStorage.getItem('authToken') || localStorage.getItem('token');
